import { c as _c } from "react/compiler-runtime";
// Copied from shared-ui 0.15.3 (loanlight-shared 6c73887) packages/ui/src/primitives/link.tsx
/**
 * TODO: Update this component to use your client-side framework's link
 * component. We've provided examples of how to do this for Next.js, Remix, and
 * Inertia.js in the Catalyst documentation:
 *
 * https://catalyst.tailwindui.com/docs#client-side-router-integration
 */

import * as Headless from "@headlessui/react";
import React, { forwardRef } from "react";
import NextLink from "next/link";
export const Link = forwardRef(function Link(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Headless.DataInteractive><NextLink {...props} ref={ref} /></Headless.DataInteractive>;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});